var ClickToBeginLoad = 'ClickToBeginLoad';
var StopAppInitialization = 'stop appInitialization';
export var MosHubScenarios = [ClickToBeginLoad, StopAppInitialization];
//# sourceMappingURL=scenariosConstants.js.map